export default "__VITE_ASSET__CzivGGgO__"